import bForm from 'bootstrap-vue/es/components/form/form';

var pyForm = {
  name: 'pyForm',
  extends: bForm
};

export default pyForm;
